import { ChampionshipDto } from '@ebf/features/championships/domain';

export const isRootUrl = () => ['/', '/championships'].includes(window.location.pathname);

export const hasPathname = (url?: string): boolean => {
  if (!url) {
    return false;
  }

  try {
    const parsed = new URL(url.startsWith('http') ? url : location.origin + url);
    return parsed.pathname.length > 1;
  } catch (e) {
    return false;
  }
};

export const buildActiveChampionshipUrl = (championship?: ChampionshipDto): string => {
  if (championship) {
    const { uuid, countryChampionships } = championship;

    return !countryChampionships.length ? `/championships` : `/championships/${uuid}?tab=countries`;
  }

  return '';
};
